import { useState } from 'react';

import { Row, Col, Button, Tooltip, Typography, Space } from 'antd';

import { CloseOutlined } from '@ant-design/icons';

import { Form, ThumbnailItem } from 'common/components';

import { ERROR_FIELD_NAME_COLLECTION } from 'common/components/preview-requirements/constants';
import { ProductEditBrandModal } from 'pages/product-full-view/components';
import {
  checkActiveStatus,
  checkRequiredPrimaryFieldForm,
  isUnitPackageLevel,
} from 'common/components/product-add/components/utils/validation';

export const BrandFieldset = (props) => {
  const {
    handleResetBrandId,
    brandThumb,
    setEditBrandVisible,
    errorInfo,
    editBrandVisible,
    productData,
    isEdit,
    setBrandId,
    setBrandThumb,
    memberIdBrand,
  } = props;

  const [selectedBrandName, setSelectedBrandName] = useState(
    isEdit ? productData?.brandName : ''
  );

  const brandError = errorInfo?.find((errorItem) =>
    errorItem.name.includes(ERROR_FIELD_NAME_COLLECTION.BRAND)
  );

  const brandErrorMessage = brandError ? brandError.errors[0] : '';

  const formInstance = Form.useFormInstance();

  const isUnit = isUnitPackageLevel(
    Form.useWatch('packageLevel', formInstance)
  );

  const isActiveStatus = checkActiveStatus(
    Form.useWatch('status', formInstance)
  );

  const brandName = selectedBrandName || productData?.brandName;

  const isRequired =
    checkRequiredPrimaryFieldForm({
      isActiveStatus,
      isUnit,
    }) && !brandName;

  return (
    <>
      <Row gutter={16}>
        <Col>
          <Form.Item
            name='brandId'
            rules={
              isRequired
                ? [
                    {
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.reject(new Error('Brand is required'));
                        }
                        return Promise.resolve();
                      },
                    },
                  ]
                : false
            }
          >
            <div>
              <div className='add-product__thumb-wrapper'>
                <div>
                  <CloseOutlined
                    className='add-product__thumb-wrapper-close-btn'
                    onClick={handleResetBrandId}
                  />
                </div>
                <ThumbnailItem
                  labelThumbnail={brandName || 'Brand Name'}
                  imageThumbnail={brandThumb}
                  hideCheckbox
                  style={{ marginLeft: 0 }}
                />
              </div>
              <Tooltip title='Choose an Brand ID'>
                <Space>
                  {isRequired && (
                    <Typography.Text
                      type='danger'
                      strong
                      style={{ fontSize: 14 }}
                    >
                      *
                    </Typography.Text>
                  )}
                  <Button onClick={() => setEditBrandVisible(true)}>
                    Link to Brand
                  </Button>
                </Space>
              </Tooltip>
            </div>
          </Form.Item>
        </Col>
      </Row>
      {brandError ? (
        <Typography.Text type='danger'>{brandErrorMessage}</Typography.Text>
      ) : null}
      {editBrandVisible && (
        <ProductEditBrandModal
          visible={editBrandVisible}
          setVisibleEditBrand={setEditBrandVisible}
          productDetail={productData}
          isAddProduct={true}
          isEdit={isEdit}
          onSelectBrand={(brand) => {
            if (brand?.brandName) setSelectedBrandName(brand?.brandName);
          }}
          setBrandId={(id) => {
            setBrandId(id);
            formInstance.setFieldsValue({ brandId: id });
            formInstance.setFields([
              {
                name: 'brandId',
                errors: [],
              },
            ]);
          }}
          setBrandThumb={setBrandThumb}
          memberIdFromBrand={memberIdBrand}
        />
      )}
    </>
  );
};
